<template>
  <div class="noticedialog">
  <div class="notice-content">
    <div class="notice">
      <div class="noticetext">
        <div>{{noticeMessage}}</div>
        <div class="sure" @click="sureClose">确 定</div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
export default {
  props:[
    "noticeMessage"
  ],
  methods: {
    sureClose() {
      this.$emit("sureClose")
    }
  }
}
</script>
<style scoped>
  .noticedialog {
    position: fixed;
    top: 0;
    bottom:0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .notice-content {
    margin: 0 auto;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
  }
  .notice {
    min-width: 300px;
    border: #fff 50px solid;
    border-image: url(../../assets/notice.png) 60 stretch;
    background: #fff;
    background-clip: padding-box;
    padding: 10px;
    box-sizing: border-box;
  }
  .noticetext {
    /*为了遮盖外层div的透明线*/
    outline: solid #fff 20px;
  }
  .sure {
    width: 90px;
    height: 30px;
    line-height: 30px;
    margin: 0 auto;
    background: #27a7ea;
    border-radius: 6px;
    color: #fff;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/notice.vue